export const subjects = {
  Telugu: [
    "Chapter 1 - దానశీలము",
    "Chapter 2 - ఎవరి భాష వాళ్ళకు వినసొంపు",
    "Chapter 3 - వీరతెలంగాణ",
    "Chapter 4 - కొత్తబాట",
    "Chapter 5 - నగర గీతం",
    "Chapter 6 - భాగ్యోదయం",
    "Chapter 7 - శతక మధురిమ",
    "Chapter 8 - లక్ష్యసిద్ధి",
    "Chapter 9 - జీవన భాష్యం",
    "Chapter 10 - గోలకొండ పట్టణము",
    "Chapter 11 - భిక్ష",
    "Chapter 12 - భూమిక"
  ],
  Hindi: [  
    "Chapter 1 - बरसते बादल",
    "Chapter 2 - ईदगाह",
    "Chapter 3 - माँ मुझे आने दे",
    "Chapter 4 - कण-कण का अधिकारी",
    "Chapter 5 - लोकगीत",
    "Chapter 6 - अंतररास्ट्रीय स्तर पर हिंदी",
    "Chapter 7 - भक्ति पद",
    "Chapter 8 - स्वराज्य की नींव",
    "Chapter 9 - दक्षिणी गंगा गोदावरी",
    "Chapter 10 - नीति दोहे",
    "Chapter 11 - जल ही जीवन है",
    "Chapter 12 - धरती के सवाल - अंतरिक्ष के जवाब ",
],
  English: [
    "Chapter 1 - Personality development",
    "Chapter 2 - Wit and humour",
    "Chapter 3 - Human Relations",
    "Chapter 4 - Films and Theatre",
    "Chapter 5 - Social issues",
    "Chapter 6 - Biodiversity",
    "Chapter 7 - Nation and diversity",
    "Chapter 8 - Human rights",
  ],
  Maths: [
    "Chapter 1 - Real numbers",
    "Chapter 2 - Sets",
    "Chapter 3 - Polynomials",
    "Chapter 4 - Pair of linear equations in two variables",
    "Chapter 5 - Quadratic questions",
    "Chapter 6 - Progressions",
    "Chapter 7 - Coordinate Geometry",
    "Chapter 8 - Similar Triangles",
    "Chapter 9 - Tangents and Secants to a Circle",
    "Chapter 10 - Mensuration",
    "Chapter 11 - Trigonometry",
    "Chapter 12 - Applications of Trigonometry",
    "Chapter 13 - Probability",
    "Chapter 14 - Statistics"
  ],
  Science: {
    physics : [    
      "Chapter 1 - Reflection of Light at curved surfaces",
      "Chapter 2 - Chemical Equations",
      "Chapter 3 - Acids, Bases and Salts",
      "Chapter 4 - Refraction of light at curved surfaces",
      "Chapter 5 - Human eye and colourful world",
      "Chapter 6 - Structure of Atom",
      "Chapter 7 - Classification of elements - The Periodic table",
      "Chapter 8 - Chemical bonding",
      "Chapter 9 - Electric current",
      "Chapter 10 - Electromagnetism",
      "Chapter 11 - Principles of Metallurgy",
      "Chapter 12 - Carbon and its compounds",
  ],
    biology : [   
      "Chapter 1 - Nutrition - Food Supplying system ",
      "Chapter 2 - Respiration - The energy producing system",
      "Chapter 3 - Transportation - The circulatory system",
      "Chapter 4 - Excretion - The wastage disposing system",
      "Chapter 5 - Coordination - The linking system",
      "Chapter 6 - Reproduction - The generating system",
      "Chapter 7 - Coordination in life processes",
      "Chapter 8 - Heredity - From parent to progeny",
      "Chapter 9 - Our environment - Our concern",
      "Chapter 10 - Natural resources",
  ]
  },
  Social: [
    "Chapter 1 - India Relief Features",
    "Chapter 2 - Ideas of Development",
    "Chapter 3 - Production and Employment",
    "Chapter 4 - Climate of India",
    "Chapter 5 - Indian Rivers and Water Resources",
    "Chapter 6 - The Population",
    "Chapter 7 - Settlements - Migrations",
    "Chapter 8 - Rampur : A Village Economy",
    "Chapter 9 - Globalisation",
    "Chapter 10 - Food Security",
    "Chapter 11 - Sustainable Development with Equity",
    "Chapter 12 - World Between the World Wars",
    "Chapter 13 - National Liberation Movements in the Colonies",
    "Chapter 14 - National Movement in India–Partition & Independence : 1939-1947",
    "Chapter 15 - The Making of Independent India’s Constitution",
    "Chapter 16 - Election Process in India",
    "Chapter 17 - Independent India (The First 30 years - 1947-77)",
    "Chapter 18 - Emerging Political Trends 1977 to 2000",
    "Chapter 19 - Post - War World and India",
    "Chapter 20 - Social Movements in Our Times",
    "Chapter 21 - The Movement for the Formation of Telangana State"
  ] 
};